<template>
    <div class="public_container customer_add_wrap">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
        </div>
        <div class="mobile_container" v-loading="loading">
            <van-form
                label-width="9.5em"
                input-align="right"
                scroll-to-error
                :show-error-message="false"
                :rules="mergeClientFormRules"
                ref="mergeClientForm"
                class=""
            >
                <div v-for="field in mergeFieldsList" :key="field.field_key">
                    <template v-if="field.field_type == 'image'">
                        <van-field
                            :required="field.is_required === 1 ? true : false"
                            v-model="mergeClientForm[field.field_key]"
                            :name="field.field_key"
                            :label="field.field_name"
                            placeholder="请选择"
                            readonly
                            class="field_column_item"
                        >
                            <div slot="input" class="image_outer_wrap">
                                <ul
                                    v-if="mergeClientForm[field.field_key] && mergeClientForm[field.field_key].length"
                                    class="upload_image_list"
                                >
                                    <li
                                        v-for="(item, index) in mergeClientForm[field.field_key]"
                                        class="upload_image_item"
                                    >
                                        <el-image
                                            :preview-src-list="
                                                mergeClientForm[field.field_key].map((urlItem) => urlItem.file_path)
                                            "
                                            :src="item.file_path"
                                            alt=""
                                        >
                                        </el-image>
                                    </li>
                                </ul>
                            </div>
                        </van-field>
                    </template>
                    <template v-else-if="field.field_type == 'file'">
                        <van-field
                            :required="field.is_required === 1 ? true : false"
                            v-model="mergeClientForm[field.field_key]"
                            :name="field.field_key"
                            :label="field.field_name"
                            placeholder="请选择"
                            readonly
                            class="field_column_item"
                        >
                            <div slot="input" class="file_upload_wrap file_upload_detail_wrap">
                                <ul
                                    v-if="mergeClientForm[field.field_key] && mergeClientForm[field.field_key].length"
                                    class="upload_file_list upload_file_list_detail"
                                >
                                    <li v-for="file in mergeClientForm[field.field_key]" class="upload_file_item">
                                        <div class="file_left_wrap">
                                            <img
                                                alt=""
                                                class="file_img"
                                                src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                            />
                                            <div class="file_info_wrap">
                                                <p class="file_name" v-text="file.file_name"></p>
                                                <p class="file_size" v-text="file.file_size"></p>
                                            </div>
                                        </div>
                                        <div class="file_right_wrap">
                                            <el-tooltip content="预览" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                                    <i class="iconfont icon-yanjing"></i>
                                                </span>
                                            </el-tooltip>
                                            <span class="line"></span>
                                            <el-tooltip content="下载" effect="dark" placement="top">
                                                <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                                    <i class="iconfont icon-daochu"></i>
                                                </span>
                                            </el-tooltip>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </van-field>
                    </template>
                    <template v-else-if="field.field_type == 'invoice'">
                        <van-field
                            :required="field.is_required === 1 ? true : false"
                            v-model="mergeClientForm[field.field_key]"
                            :name="field.field_key"
                            :label="field.field_name"
                            placeholder="请选择"
                            readonly
                            class="field_column_item"
                        >
                            <div slot="input" class="">
                                <ul
                                    v-if="mergeClientForm[field.field_key] && mergeClientForm[field.field_key].length"
                                    class="invoice_list"
                                >
                                    <li v-for="item in mergeClientForm[field.field_key]" class="invoice_item">
                                        <div class="invoice_title_wrap">
                                            <span class="purchaser_name" v-text="item.purchaser_name"></span>
                                            <el-link
                                                :underline="false"
                                                type="primary"
                                                @click="handleClickPreviewInvoiceFile(item)"
                                                >发票预览
                                            </el-link>
                                        </div>
                                        <div class="invoice_total_amount" v-text="'￥' + item.total_amount"></div>
                                    </li>
                                </ul>
                            </div>
                        </van-field>
                    </template>
                    <template v-else-if="field.field_type == 'table'">
                        <van-field
                            :required="field.is_required === 1 ? true : false"
                            v-model="mergeClientForm[field.field_key]"
                            :name="field.field_key"
                            :label="field.field_name"
                            placeholder="请选择"
                            readonly
                            class="field_column_item"
                        >
                            <div slot="input" class="">
                                <div v-if="field.filling_method === 'horizontal'" class="horizontal_table_outer_wrap">
                                    <div class="horizontal_table_inner_wrap">
                                        <div class="horizontal_table_list_wrap">
                                            <ul class="horizontal_table_header_list">
                                                <li
                                                    v-for="table_item in field._child.filter(
                                                        (field) => !field.initial_display
                                                    )"
                                                    :style="{ width: table_item.min_width }"
                                                    class="horizontal_table_header_item"
                                                >
                                                    <span v-text="table_item.field_name"></span>
                                                    <ul v-if="table_item.phone_type === '3'" class="phone_type_list">
                                                        <li
                                                            :class="{ active: table_phone_type === '1' }"
                                                            class="phone_type_item"
                                                            @click="
                                                                handleClickTableTelePhoneType('1', field, table_item)
                                                            "
                                                        >
                                                            手机
                                                        </li>
                                                        <li
                                                            :class="{ active: table_phone_type === '2' }"
                                                            class="phone_type_item"
                                                            @click="
                                                                handleClickTableTelePhoneType('2', field, table_item)
                                                            "
                                                        >
                                                            固话
                                                        </li>
                                                    </ul>
                                                </li>
                                            </ul>
                                            <ul>
                                                <li v-for="(row, index) in mergeClientForm[field.field_key]">
                                                    <el-form
                                                        :ref="`table_item_form_${field.field_key}_${index}`"
                                                        :model="row"
                                                        :rules="field.formRules"
                                                        size="small"
                                                    >
                                                        <ul class="horizontal_table_body_tr">
                                                            <li
                                                                v-for="child in field._child"
                                                                :key="child.field_key"
                                                                :class="{
                                                                    horizontal_table_body_disabled_td:
                                                                        child.field_type === 'compute_mode' ||
                                                                        (child.field_type === 'department' &&
                                                                            child.default) ||
                                                                        (child.field_type === 'date' && child.default),
                                                                }"
                                                                :style="{ width: child.min_width }"
                                                                class="horizontal_table_body_td"
                                                            >
                                                                <el-form-item
                                                                    v-if="child.field_type === 'input'"
                                                                    :prop="child.field_key"
                                                                >
                                                                    <span
                                                                        v-text="row[child.field_key].value || '--'"
                                                                    ></span>
                                                                </el-form-item>
                                                                <el-form-item
                                                                    v-else-if="child.field_type === 'textarea'"
                                                                    :prop="child.field_key"
                                                                >
                                                                    <span
                                                                        v-text="row[child.field_key].value || '--'"
                                                                    ></span>
                                                                </el-form-item>
                                                                <el-form-item
                                                                    v-else-if="child.field_type === 'number'"
                                                                    :prop="child.field_key"
                                                                >
                                                                    <span
                                                                        v-text="row[child.field_key].text || '--'"
                                                                    ></span>
                                                                </el-form-item>
                                                                <el-form-item
                                                                    v-else-if="child.field_type === 'money'"
                                                                    :prop="child.field_key"
                                                                >
                                                                    <span
                                                                        v-text="row[child.field_key].text || '--'"
                                                                    ></span>
                                                                    <span
                                                                        v-if="row[child.field_key].chinese_text"
                                                                        class="chinese_text"
                                                                        v-text="row[child.field_key].chinese_text"
                                                                    ></span>
                                                                </el-form-item>
                                                                <el-form-item
                                                                    v-else-if="child.field_type === 'compute_mode'"
                                                                    :prop="child.field_key"
                                                                >
                                                                    <span
                                                                        v-text="row[child.field_key].text || '--'"
                                                                    ></span>
                                                                    <span
                                                                        v-if="row[child.field_key].chinese_text"
                                                                        class="chinese_text"
                                                                        v-text="row[child.field_key].chinese_text"
                                                                    ></span>
                                                                </el-form-item>
                                                                <el-form-item
                                                                    v-else-if="child.field_type === 'telephone'"
                                                                    :prop="child.field_key"
                                                                >
                                                                    <span
                                                                        v-text="row[child.field_key].text || '--'"
                                                                    ></span>
                                                                </el-form-item>
                                                                <el-form-item
                                                                    v-else-if="child.field_type === 'radio'"
                                                                    :prop="child.field_key"
                                                                    filterable
                                                                >
                                                                    <span
                                                                        v-text="row[child.field_key].text || '--'"
                                                                    ></span>
                                                                </el-form-item>
                                                                <el-form-item
                                                                    v-else-if="child.field_type === 'checkbox'"
                                                                    :prop="child.field_key"
                                                                >
                                                                    <span
                                                                        v-text="
                                                                            row[child.field_key].text &&
                                                                            row[child.field_key].text.length
                                                                                ? row[child.field_key].text.text
                                                                                : '--'
                                                                        "
                                                                    ></span>
                                                                </el-form-item>
                                                                <el-form-item
                                                                    v-else-if="child.field_type === 'cascader'"
                                                                    :prop="child.field_key"
                                                                >
                                                                    <span
                                                                        v-text="row[child.field_key].text || '--'"
                                                                    ></span>
                                                                </el-form-item>
                                                                <el-form-item
                                                                    v-else-if="child.field_type === 'date'"
                                                                    :prop="child.field_key"
                                                                >
                                                                    <span
                                                                        v-text="row[child.field_key].text || '--'"
                                                                    ></span>
                                                                </el-form-item>
                                                                <el-form-item
                                                                    v-else-if="child.field_type === 'date_range'"
                                                                    :prop="child.field_key"
                                                                >
                                                                    <span
                                                                        v-text="row[child.field_key].text || '--'"
                                                                    ></span>
                                                                </el-form-item>
                                                            </li>
                                                        </ul>
                                                    </el-form>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </van-field>
                    </template>
                    <template v-else-if="field.field_type == 'relate_approve_form'"> </template>
                    <template v-else>
                        <van-field
                            :required="field.is_required === 1 ? true : false"
                            v-model="mergeClientForm[field.field_key]"
                            :name="field.field_key"
                            :label="field.field_name"
                            placeholder="请选择"
                            is-link
                            readonly
                            @click="handleClickSelect(field, mergeClientForm, mergeFieldsList)"
                            :rules="[{ required: field.is_required === 1 ? true : false, message: '请选择' }]"
                        >
                        </van-field>
                    </template>
                </div>
            </van-form>

        </div>
        <div class="add_footer_wrap">
            <van-button round block type="info" :disabled="btnDisabled" @click="handleClickConfirm">确定</van-button>
        </div>

        <van-overlay
            :show="showRadioPicker"
            v-if="showRadioPicker"
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' ,  zIndex: 999}"
        >
            <div class="radio_option_wrap">
                <ul class="radio_option_list">
                    <li
                        v-for="item in currentOptions"
                        class="radio_option_item"
                        @click="handleClickRadioOption(item)"
                        v-text="item.text"
                    ></li>
                </ul>
                <div class="cancel_btn" @click="showRadioPicker = false">取消</div>
            </div>
        </van-overlay>
        <el-image ref="preview_img" :preview-src-list="previewImgList" :src="previewImgSrc" style="display: none">
        </el-image>
        <!--发票详情-->
        <el-dialog
            v-if="invoiceDetailDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :visible.sync="invoiceDetailDialogVisible"
            append-to-body
            custom-class="custom_form_dialog"
            title="发票明细"
            width="820px"
            @close="handleClickInvoiceInfoDialogCancel"
        >
            <ul class="invoice_info_list">
                <li v-for="item in invoiceFilesList" class="invoice_info_item">
                    <div class="invoice_image_wrap">
                        <el-image
                            v-if="item.file_type === 'image'"
                            :preview-src-list="[item.file_path]"
                            :src="item.file_path"
                        >
                        </el-image>
                        <iframe v-else :src="item.file_path" frameborder="0"></iframe>
                    </div>
                    <el-form size="small">
                        <div class="page_little_title"><span class="title">发票基本信息</span></div>
                        <el-form-item label="发票类型：" prop="op">
                            <div v-text="invoiceOptionText(item.op)"></div>
                        </el-form-item>
                        <el-form-item v-if="item.invoice_code" label="发票代码：" prop="invoice_code">
                            <div v-text="item.invoice_code"></div>
                        </el-form-item>
                        <el-form-item label="发票号码：" prop="invoice_number">
                            <div v-text="item.invoice_number"></div>
                        </el-form-item>
                        <el-form-item v-if="item.invoice_date" label="开票日期：" prop="invoice_date">
                            <div v-text="item.invoice_date"></div>
                        </el-form-item>
                        <el-form-item v-if="item.check_code" label="校验码：" prop="checkCode">
                            <div v-text="item.check_code"></div>
                        </el-form-item>
                        <div
                            v-if="
                                item.purchaser_name ||
                                item.purchaser_tax_number ||
                                item.purchaser_contact_info ||
                                item.purchaser_bank_account_info
                            "
                            class="page_little_title"
                        >
                            <span class="title">购方信息</span>
                        </div>
                        <el-form-item v-if="item.purchaser_name" label="名称：" prop="purchaser_name">
                            <div v-text="item.purchaser_name"></div>
                        </el-form-item>
                        <el-form-item
                            v-if="item.purchaser_tax_number"
                            label="纳税人识别号："
                            prop="purchaser_tax_number"
                        >
                            <div v-text="item.purchaser_tax_number"></div>
                        </el-form-item>
                        <el-form-item
                            v-if="item.purchaser_contact_info"
                            label="地址、电话："
                            prop="purchaser_contact_info"
                        >
                            <div v-text="item.purchaser_contact_info"></div>
                        </el-form-item>
                        <el-form-item
                            v-if="item.purchaser_bank_account_info"
                            label="开户行及账号："
                            prop="purchaser_bank_account_info"
                        >
                            <div v-text="item.purchaser_bank_account_info"></div>
                        </el-form-item>
                    </el-form>
                </li>
            </ul>
            <div slot="footer">
                <el-button size="small" @click="handleClickInvoiceInfoDialogCancel">取消</el-button>
                <el-button size="small" type="primary" @click="handleClickInvoiceInfoDialogConfirm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {EventBus} from '@/utils/eventBus';
import { CustomerPrivateMergeList, getFormFields, CustomerPrivateMerge } from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import { getOSSData } from "@/utils/uploadOss";
export default {
    name: "MCustomerMerge",
    components: { ReturnNavBar },
    data() {
        return {
            customer_ids: [],
            loading: false,
            btnDisabled: false,
            mergeFieldsList: [],
            mergeClientForm: {},
            mergeClientFormRules: {},
            mergeClientFormSelectData: {},
            currentField: {},
            currentOptions: [],
            showRadioPicker: false,
            nowFieldData: {},
            submitMergeClientForm: {},

            previewImgList: [],
            previewImgSrc: "",

            invoiceFilesList: [],
            invoiceDetailDialogVisible: false,
            invoiceInfoPreview: false,
        };
    },
    created() {
        const customerIds = JSON.parse(localStorage.getItem("customerMergeIds"));
        this.customer_ids = customerIds || [];
        this.getCustomerPrivateMergeList();
    },
    methods: {
        getCustomerPrivateMergeList() {
            this.loading = true;
            CustomerPrivateMergeList({ customer_ids: this.customer_ids })
                .then((res) => {
                    if (res.code === 200) {
                        const {data} = res.data;
                        this.mergeCompanyInfoList = data || [];
                        this.getFieldList();
                    } else {
                        this.loading = false;
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getFieldList() {
            getFormFields({
                field_form: "customers",
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.mergeFieldsList = res.data
                            .filter(
                                (item) =>
                                    item.field_type !== "explain" &&
                                    item.field_key !== "crm_contact" &&
                                    item.field_key !== "name"
                            )
                            .map((field) => {
                                this.$set(this.mergeClientForm, field.field_key, "");
                                this.$set(this.mergeClientFormRules, field.field_key, [
                                    {
                                        required: true,
                                        message: "请选择" + field.field_name,
                                        trigger: "change",
                                    },
                                ]);
                                this.$set(this.mergeClientFormSelectData, field.field_key, []);
                                return {
                                    ...field,
                                    ...field.extend,
                                    customer_id: undefined,
                                };
                            });
                        this.mergeFieldsList.unshift({
                            field_key: "customer_id",
                            field_type: "primary_customer",
                            field_name: "主客户",
                            customer_id: undefined,
                        });
                        this.$set(this.mergeClientFormSelectData, "customer_id", []);
                        this.$set(this.mergeClientFormRules, "customer_id", [
                            {
                                required: true,
                                message: "请选择主客户",
                                trigger: "change",
                            },
                        ]);
                        this.$nextTick(() => {
                            this.$refs.mergeClientForm.resetValidation();
                            this.getFieldValueList(this.mergeFieldsList, this.mergeCompanyInfoList);
                        });
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        getFieldValueList(mergeFieldsList, mergeCompanyInfoList) {
            mergeFieldsList.forEach((field) => {
                mergeCompanyInfoList.forEach((item) => {
                    if (!item.hasOwnProperty(field.field_key)) {
                        if (field.field_key == "customer_id") {
                            this.mergeClientFormSelectData[field.field_key].push({
                                text: item.name.value || "空",
                                value: item.id,
                                customer_id: item.id,
                            });
                        } else {
                            this.mergeClientFormSelectData[field.field_key].push({
                                text: "空",
                                value: "",
                                customer_id: item.id,
                            });
                        }
                    } else {
                        switch (field.field_type) {
                            case "input":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key].value || "空",
                                    value: item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "textarea":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key].value || "空",
                                    value: item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "number":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key].text || "空",
                                    value: item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "money":
                                const unit = item[field.field_key]
                                    ? item[field.field_key].unit === "￥"
                                        ? "（CNY-人民币）"
                                        : "（USD-美元）"
                                    : "";
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key].text ? item[field.field_key].text + unit : "空",
                                    value: item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "compute_mode":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key].text || "空",
                                    value: item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "telephone":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key].value || "空",
                                    value: item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "radio":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key].text || "空",
                                    value: item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "checkbox" || "checkbox_user_tag" || "cascader":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key].text ? item[field.field_key].text.join() : "空",
                                    value: item[field.field_key].value ? item[field.field_key].value.join() : "",
                                    customer_id: item.id,
                                });
                                break;
                            case "date":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key].value || "空",
                                    value: item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "date_range":
                                const date =
                                    item[field.field_key] && item[field.field_key].value
                                        ? item[field.field_key].value.join("~")
                                        : "";
                                const duration =
                                    item[field.field_key].auto_computed &&
                                    item[field.field_key] &&
                                    item[field.field_key].duration
                                        ? `（${item[field.field_key].duration}）`
                                        : "";
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: `${date}${duration}` || "空",
                                    value: item[field.field_key].value || "",
                                    customer_id: item.id,
                                });
                                break;
                            case "address":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text:
                                        item[field.field_key].text && item[field.field_key].text.length
                                            ? item[field.field_key].text
                                            : "空",
                                    value: item[field.field_key].value
                                        ? item[field.field_key].value.join("") + item.id
                                        : "",
                                    customer_id: item.id,
                                });
                                break;
                            case "contact":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text:
                                        item[field.field_key] && item[field.field_key].text
                                            ? item[field.field_key].text.map((user) => user.name).join()
                                            : "空",
                                    value: item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "customer_contact":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text:
                                        item[field.field_key] && item[field.field_key].text
                                            ? item[field.field_key].text.map((user) => user.name).join()
                                            : "空",
                                    value: item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "department":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text:
                                        item[field.field_key].titles && item[field.field_key].titles.length
                                            ? item[field.field_key].titles[0]
                                            : "空",
                                    value:
                                        item[field.field_key].value && item[field.field_key].value.length
                                            ? item[field.field_key].value
                                            : "",
                                    customer_id: item.id,
                                });
                                break;
                            case "image":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    value: item[field.field_key],
                                    customer_id: item.id,
                                });
                                break;
                            case "file":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    value: item[field.field_key],
                                    customer_id: item.id,
                                });
                                break;
                            case "invoice":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    value: item[field.field_key],
                                    customer_id: item.id,
                                });
                                break;
                            case "table":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    value: item[field.field_key],
                                    customer_id: item.id,
                                });
                                break;
                            case "id_card":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key] && item[field.field_key].value,
                                    value: item[field.field_key] && item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "rate":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key] && item[field.field_key].text,
                                    value: item[field.field_key] && item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            case "paying_teller":
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: item[field.field_key] && item[field.field_key].text,
                                    value: item[field.field_key] && item[field.field_key].value,
                                    customer_id: item.id,
                                });
                                break;
                            default:
                                this.mergeClientFormSelectData[field.field_key].push({
                                    text: "空",
                                    value: "",
                                    customer_id: item.id,
                                });
                        }
                    }
                });
            });
        },
        // 选择框选择
        handleClickSelect(field, formData, mergeFieldsList) {
            this.currentField = field;
            this.showRadioPicker = true;
            this.currentOptions = this.mergeClientFormSelectData[field.field_key];
        },
        // 选择完成
        handleClickRadioOption(item) {
            this.$set(this.mergeClientForm, this.currentField.field_key, item.text);
            this.handleMergeSelChange(
                this.currentField,
                item.value,
                this.mergeClientFormSelectData[this.currentField.field_key]
            );
        },
        handleMergeSelChange(field, value, list) {
            if (field.field_key === "customer_id") {
                const company = this.mergeCompanyInfoList.find((item) => item.id == value);
                this.mergeFieldsList.forEach((fieldItem) => {
                    if (
                        company.hasOwnProperty(fieldItem.field_key) &&
                        this.mergeClientForm.hasOwnProperty(fieldItem.field_key)
                    ) {
                        let mergeFieldData = [];
                        if (
                            fieldItem.field_type == "checkbox" ||
                            fieldItem.field_type == "checkbox_user_tag" ||
                            fieldItem.field_type == "cascader"
                        ) {
                            if (Array.isArray(company[fieldItem.field_key].text)) {
                                this.$set(
                                    this.mergeClientForm,
                                    fieldItem.field_key,
                                    company[fieldItem.field_key].text ? company[fieldItem.field_key].text.join(",") : ""
                                );
                            } else {
                                this.$set(
                                    this.mergeClientForm,
                                    fieldItem.field_key,
                                    company[fieldItem.field_key].text || "空"
                                );
                            }
                        } else if (fieldItem.field_type == "department") {
                            this.$set(
                                this.mergeClientForm,
                                fieldItem.field_key,
                                company[fieldItem.field_key].titles && company[fieldItem.field_key].titles.length
                                    ? company[fieldItem.field_key].titles[0]
                                    : "空"
                            );
                        } else if (fieldItem.field_type == "address") {
                            this.$set(
                                this.mergeClientForm,
                                fieldItem.field_key,
                                company[fieldItem.field_key].text && Array.isArray(company[fieldItem.field_key].text)
                                    ? company[fieldItem.field_key].text.join("")
                                    : company[fieldItem.field_key].text
                            );
                        } else if (fieldItem.field_type == "contact" || fieldItem.field_type == "customer_contact") {
                            this.$set(
                                this.mergeClientForm,
                                fieldItem.field_key,
                                company[fieldItem.field_key].text && Array.isArray(company[fieldItem.field_key].text)
                                    ? company[fieldItem.field_key].text.map((user) => user.name).join()
                                    : company[fieldItem.field_key].text
                            );
                        } else if (
                            fieldItem.field_type == "image" ||
                            fieldItem.field_type == "file" ||
                            fieldItem.field_type == "invoice" ||
                            fieldItem.field_type == "table"
                        ) {
                            // 合并客户：明细表格，关联审批单，关联打卡记录，图片，附件，发票这几个控件直接主客户和其他客户合并到一起
                            const customFieldData = company[fieldItem.field_key] || [];
                            const otherCustomData = this.mergeCompanyInfoList.filter((item) => item.id != value);
                            const otherFieldCustomData = otherCustomData.map((item) => item[fieldItem.field_key] || []);
                            mergeFieldData = customFieldData.concat(otherFieldCustomData).flat(Infinity);
                            this.$set(this.mergeClientForm, fieldItem.field_key, mergeFieldData);
                        } else {
                            this.$set(this.mergeClientForm, fieldItem.field_key, company[fieldItem.field_key].value);
                        }

                        if (
                            fieldItem.field_type == "image" ||
                            fieldItem.field_type == "file" ||
                            fieldItem.field_type == "invoice" ||
                            fieldItem.field_type == "table"
                        ) {
                            this.$set(this.submitMergeClientForm, fieldItem.field_key, mergeFieldData);
                        } else {
                            this.$set(this.submitMergeClientForm, fieldItem.field_key, company[fieldItem.field_key]);
                        }
                    }
                });
                this.$set(this.mergeClientForm, "customer_id", company.name && company.name.value);
                this.$set(this.submitMergeClientForm, "name", company.name);
                this.$set(this.submitMergeClientForm, "customer_id", value);
                this.submitMergeClientForm.delete_customer_ids = this.mergeCompanyInfoList
                    .map((item) => item.id)
                    .filter((item) => item !== value);
            } else {
                const selectList = list.find((item) => item.value == value);
                const company_id = selectList.customer_id;
                if (company_id) {
                    const company = this.mergeCompanyInfoList.find((item) => item.id == company_id);
                    this.$set(this.submitMergeClientForm, field.field_key, company[field.field_key]);
                }
            }
            this.showRadioPicker = false;
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        //预览发票文件
        handleClickPreviewInvoiceFile(invoice) {
            this.invoiceFilesList = [invoice];
            this.invoiceInfoPreview = true;
            this.invoiceDetailDialogVisible = true;
        },
        // 提交
        handleClickConfirm() {
            this.$refs.mergeClientForm.validate().then(() => {
                this.loading = true;
                this.btnDisabled = true;
                // console.log(this.submitMergeClientForm, 'form===')
                CustomerPrivateMerge(this.submitMergeClientForm)
                    .then((res) => {
                        if (res.code === 200) {
                            this.$toast({
                                message: res.message,
                                type: "success",
                                duration: 1000,
                                onClose: () => {
                                    EventBus.$emit('customerEditUpdated');
                                    this.$router.go(-1);
                                },
                            });
                        }
                        this.loading = false;
                        this.btnDisabled = false;
                    })
                    .catch(() => {
                        this.loading = false;
                        this.btnDisabled = false;
                    });
            });
        },
    },
    beforeDestroy() {
        localStorage.removeItem("customerMergeIds");
    }
};
</script>
<style lang="scss" scoped>
.customer_add_wrap {
    .mobile_container {
        padding: 10px 0;
    }
    .add_footer_wrap {
        padding: 5px 16px;
        background-color: #f7f8fa;

        .van-button {
            border-radius: 8px;
            height: 38px;
            background-color: rgba(41, 144, 240, 1);
            border-color: rgba(41, 144, 240, 1);
        }
    }
    .field_column_item {
        flex-direction: column;
        ::v-deep {
            .van-field__value {
                text-align: left;
            }
            .van-field__control {
                text-align: left;
            }
            .van-field__body {
                .van-field__control {
                    display: block;
                }
            }
        }
    }
    .image_outer_wrap {
        padding-left: 6px;

        .image_upload_wrap {
            width: 48px;
            height: 48px;
            opacity: 1;
            border-radius: 4px;
            background: #edf0f4;
            border: 1px dashed #d9d9d9;
            text-align: center;
            line-height: 48px;
            margin-bottom: 2px;
            cursor: pointer;
            position: relative;

            .upload_input {
                width: 100%;
                height: 100%;
                position: absolute;
                left: 0;
                top: 0;
                opacity: 0;
                cursor: pointer;
            }
        }

        .upload_image_list {
            display: flex;
            flex-wrap: wrap;
            gap: 8px;

            .upload_image_item {
                width: 48px;
                height: 48px;
                opacity: 1;
                border-radius: 4px;
                text-align: center;
                line-height: 48px;
                position: relative;

                .el-image {
                    width: 100%;
                    height: 100%;
                    border-radius: 4px;
                }
            }
        }

        .image_hint {
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: #999999;
        }
    }
    .invoice_list {
        width: 100%;

        .invoice_item {
            width: 100%;
            padding: 8px 12px;
            border-radius: 2px;
            background: #edf0f4;
            margin-bottom: 8px;

            .invoice_title_wrap {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 4px;
                line-height: 22px;

                .purchaser_name {
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 22px;
                    color: #666666;
                }
            }

            .invoice_total_amount {
                font-weight: 700;
                line-height: 22px;
                color: #333333;
            }
        }
    }
    .invoice_info_list {
        padding: 24px;

        .invoice_info_item {
            .invoice_image_wrap {
                width: 100%;
                border-radius: 2px;
                background: #f7f8fa;
                padding: 8px;
                height: 516px;
                margin-bottom: 24px;

                .el-image {
                    width: 100%;
                    height: 100%;
                }

                iframe {
                    width: 100%;
                    height: 100%;
                }
            }

            .el-form-item {
                margin-bottom: 8px !important;

                .el-form-item__label {
                    line-height: 22px;
                    color: #999999;
                }

                .el-form-item__content {
                    line-height: 22px;
                    color: #333333;
                }
            }
        }
    }
}
.radio_option_wrap {
    width: 100%;
    height: 100%;
    padding: 0 16px 35px;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    .radio_option_list {
        max-height: calc(100% - 90px);
        overflow-y: auto;
        border-radius: 8px;

        .radio_option_item {
            background-color: #ffffff;
            text-align: center;
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            padding: 10px 0;
            color: #666666;
            border-bottom: 1px solid #dedede;

            &:first-child {
                border-radius: 8px 8px 0 0;
            }

            &:last-child {
                border-bottom: none;
                border-radius: 0 0 8px 8px;
            }
        }
    }

    .cancel_btn {
        background-color: #ffffff;
        text-align: center;
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        padding: 10px 0;
        color: #666666;
        border-radius: 8px;
        box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
        margin-top: 10px;
    }
}
</style>
